import { useEffect, useState } from 'react';
import Select from 'react-select';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Sidenavbar from '../../Components/Sidenavbar/Sidenavbar';
import UserMenu from '../../Components/UserMenu/UserMenu';
import DashboardCard from '../../Components/DashboardCard/DashboardCard';
import { postData } from '../../Services/apiService';

const currentYear = new Date().getFullYear();
const startYear = 2022;
const years = [];
for (let year = startYear; year <= currentYear; year++) {
  years.push({ value: year.toString(), label: year.toString() });
}

function AdminDashboard(props) {
  const userType = 'admin';
  const [requestsList, setRequestsList] = useState([]);
  const [selectedYear, setSelectedYear] = useState(currentYear);
  const [profiles, setProfiles] = useState([]);  

  const [profile, setProfile] = useState(
    localStorage.getItem('selectedProfile')
      ? parseInt(localStorage.getItem('selectedProfile'))
      : profiles.length > 0
      ? profiles[0].value
      : 1
  );
  

  useEffect(() => {
    fetchRequestsPerMonth();
  }, [selectedYear, profile]);

  const fetchRequestsPerMonth = async () => {
    const requestURL = `TrasferRequest/GetAll`;
    const user = JSON.parse(localStorage.getItem('user')) || {};
    const idUser = user.id || 0;
    const body = {
      idUser: idUser,
      profile: profile,
      year: selectedYear,
    };
    const request = await postData(requestURL, body);
    if (request.succes === true) {
      setRequestsList(request.data);
    } else {
      toast.error('Error fetching data');
    }
  };

  const handleYearChange = (selectedOption) => {
    setSelectedYear(selectedOption.value); // Actualiza el año seleccionado
  };

  const handleProfileChange = (selectedOption) => {
    setProfile(selectedOption.value); // Actualiza el perfil seleccionado
    localStorage.setItem('selectedProfile', selectedOption.value); // Guarda el perfil seleccionado en localStorage
  };

  // Solo renderizamos el Select si hay perfiles disponibles
  const profileSelect = profiles.length > 0 ? (
    <Select
      options={profiles}
      onChange={handleProfileChange}
      value={profiles.find((profileOption) => profileOption.value === profile)}
      isLoading={profiles.length === 0}
    />
  ) : (
    <p>Cargando perfiles...</p>
  );

  return (
    <div className="container-fluid px-0 m-0 d-flex flex-column flex-md-row">
      <Sidenavbar userType={userType} />
      <div className="container-fluid px-16">
        <UserMenu userType="admin" setProfiles={setProfiles}/>
        <ToastContainer />

        {/* Dashboard */}
        <div className="row mt-40">
          <div className="col-12 col-md-6 col-lg-3">
            <label className="input-label">Año</label>
            <Select
              options={years}
              onChange={handleYearChange}
              defaultValue={years.find((year) => year.value === currentYear.toString())}
            />
          </div>
          <div className="col-12 col-md-6 col-lg-3">
            <label className="input-label">Perfil</label>
            {profileSelect}
          </div>
        </div>

        <div className="row mt-24">
          {requestsList.map((request, index) => (
            <div className="col-12 mt-16" key={index}>
              <DashboardCard 
                initialTitle={request.title} 
                buttonText="Ver más"
                received={request.recibidas}
                pending={request.pendientes}
                approved={request.aprobadas}
                rejected={request.rechazadas}
                year={request.year}
                month={request.month}
                profile={profile}
                initialButtonLink="/DetailsDashboard" 
              />
            </div>
          ))}
        </div>
        {/* Dashboard */}
      </div>
    </div>
  );
}

export default AdminDashboard;
